import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/slices/Auth";
import suiteSlice from "../features/slices/Suite";
import groupSlice from "../features/slices/UserGroups";
import equipmentSlice from "../features/slices/Equipment";
import caseSlice from "../features/slices/Case";
import agentSlice from "../features/slices/Agent";
import resourceSlice from "../features/slices/Resource";
import usersSlice from "../features/slices/Users";
import notificationSlice from "../features/slices/Notification";
import logger from "redux-logger";

const reducer = {
  auth: authReducer,
  suite: suiteSlice,
  UserGroups: groupSlice,
  equipment: equipmentSlice,
  cases: caseSlice,
  agents: agentSlice,
  resources: resourceSlice,
  users: usersSlice,
  notifications: notificationSlice,
};

const store = configureStore({
  reducer: reducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
